const {pushDataLayerEvent} = require('./dataLayer');
const {getContactDetails} = require('./contactDetails');

function createGenerateLeadEvent(value, currency, email) {
    return {
        event: 'generate_lead',
        ecommerce: {
            currency,
            value,
        },
        user_data: {
            email_address: getContactDetails({email}).email,
        },
    };
}

function trackGenerateLead(value, currency, source, email) {
    return pushDataLayerEvent(createGenerateLeadEvent(value, currency, email), {
        source,
    });
}

module.exports = {
    createGenerateLeadEvent,
    trackGenerateLead,
};
